// extracted by css-extract-rspack-plugin
export default {"issue-list-header-layout":"issue-list-header-layout-U1lI2Q","issueListHeaderLayout":"issue-list-header-layout-U1lI2Q","name":"name-ILcaMi","info":"info-l9l08q"};